/**
 * Copyright ©2023 Drivepoint
 */

import {Store} from "@bainbridge-growth/node-frontend";
import WebAppServerClient from "../clients/WebAppServerClient";
import State from "../state/State";
import {StateEvent} from "../state/StateEvent";

export default class ExcelCompanyStore extends Store {

  private _dataSources: Record<string, any>;
  private _summaryForAgent: string;
  private _agentFinancialAutomappingInstructions: string;

  init(): void {
    State.register("excel_company", (event: StateEvent) => {
      this.value = [];
      this.value = event.value;
      this._dataSources = {};
      this._summaryForAgent = "";
      this._agentFinancialAutomappingInstructions = "";
    });
  }

  async update(data: any): Promise<any> {
    return this.action(async () => {
      return await WebAppServerClient.request(`/ui/company/${this.value.id}/updateCompany`, "PATCH", data);
    });
  }

  async upgradeCompanyTier(tier: string) {
    return this.action(async () => {
      return await WebAppServerClient.request(`/ui/company/${this.value.id}/upgradeCompany`, "POST", {tier}, undefined, {keepalive: true});
    });
  }

  async getActiveDataSourcesForCompany(company_id: string): Promise<any> {
    return this.action(async () => {
      this._dataSources =  await WebAppServerClient.request(`/ui/company/${company_id}/activeDataSources`, "GET");
    });
  }

  async getSummaryForAgent(company_id: string): Promise<any> {
    return this.action(async () => {
      const res = await WebAppServerClient.request(`/ui/company/${company_id}/summaryForAgent`, "GET");
      this._summaryForAgent = res?.summary;
    });
  }

  async getAgentFinancialAutomappingInstructions(company_id: string): Promise<any> {
    return this.action(async () => {
      const res = await WebAppServerClient.request(`/ui/company/${company_id}/agentFinancialAutomappingInstructions`, "GET");
      this._agentFinancialAutomappingInstructions = res?.agent_financial_automapping_instructions;
    });
  }

  get dataSources() {
    return this._dataSources;
  }

  get summaryForAgent() {
    return this._summaryForAgent;
  }

  get agentFinancialAutomappingInstructions() {
    return this._agentFinancialAutomappingInstructions;
  }

}
